(function () {

    //Экран email
    const formEmail = $('.js-form-email');
    const buttonDuplicateEmail = $('.button--duplicate-email');

    buttonDuplicateEmail.on('click', function () {
        if (!validator(formEmail)) {
            formEmail.submit();
        }
    })
})();
